// removed by extract-text-webpack-plugin
module.exports = {"select":"_3kq1-jwknB1iPrzxZhjgum"};


//////////////////
// WEBPACK FOOTER
// ./components/AppMenu/style.less
// module id = 1290
// module chunks = 0